import moment from 'moment'

// The utilization report's primary period is a quarter (1-4) or 'ytd': January
// 1st through today for the current year, through December 31st for any other.

export const YTD = 'ytd'

// Reads the quarter off the URL: '4' -> 4, 'ytd' -> 'ytd', junk -> null.
export const parseQuarter = (value) => {
    if (value === YTD) {
        return YTD
    }
    const quarter = parseInt(value, 10)
    return quarter >= 1 && quarter <= 4 ? quarter : null
}

export const periodLabel = (quarter, year) => quarter === YTD ? `YTD ${year}` : `Q${quarter} ${year}`

const toMoment = value => moment.isMoment(value) ? value.clone() : moment(value, 'YYYY-MM-DD')

// Classifies a stored date range back into the quarter or YTD it was built for.
// A range that starts in January and does not end in March can only be a YTD;
// a YTD built on March 31st is Q1's exact range, so it reads as Q1 -- same data.
export const reportPeriod = (start, end) => {
    const sd = toMoment(start)
    const ed = toMoment(end)
    if (!start || !end || !sd.isValid() || !ed.isValid()) {
        return null
    }
    const year = sd.year()
    const quarter = sd.month() === 0 && ed.month() !== 2 ? YTD : sd.quarter()
    return { year, quarter, label: periodLabel(quarter, year) }
}

// [start, end] moments for a (year, quarter) selection.
export const periodRange = (year, quarter) => {
    const start = moment().year(year).startOf('year')
    if (quarter === YTD) {
        const end = year === moment().year() ? moment().endOf('day') : start.clone().endOf('year')
        return [start, end]
    }
    return [start.clone().quarter(quarter).startOf('quarter'), start.clone().quarter(quarter).endOf('quarter')]
}
